import { createContext, useReducer, type ReactNode, type Dispatch } from 'react';
import type { AppState } from '../types';
import { appStateReducer, type Action } from './reducer';
import { createDefaultAppState } from '../lib/defaultState';

interface AppStateContextValue {
  state: AppState;
  dispatch: Dispatch<Action>;
}

export const AppStateContext = createContext<AppStateContextValue | null>(null);

export function AppStateProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(appStateReducer, null, createDefaultAppState);

  return (
    <AppStateContext.Provider value={{ state, dispatch }}>
      {children}
    </AppStateContext.Provider>
  );
}

